import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseCommentImporterSelectors = importerSelectors(
  'courseComment.importer',
)

export default courseCommentImporterSelectors
